var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-group',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var ariaDescribedby = ref.ariaDescribedby;
return [_c('b-form-checkbox-group',{attrs:{"options":_vm.filterOptions,"aria-describedby":ariaDescribedby,"switches":"","name":"button-filter"},model:{value:(_vm.localState),callback:function ($$v) {_vm.localState=$$v},expression:"localState"}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }